// https://stackoverflow.com/questions/9815762/detect-when-an-image-fails-to-load-in-javascript
const tryImageLoad = (url) => new Promise((resolve, reject) => {
  const img = new Image();
  img.addEventListener('load', () => resolve());
  img.addEventListener('error', () => reject());
  img.src = url;
});

export default tryImageLoad;
